import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#FFCC00",
            text: "#ffffff",
        },
        secondary: {
            main: "#10446F",
            supMain: "#939494"
        },
        background: {
            default: "#fff",
        },
    },
    typography: {
        h1: {
            fontFamily: "Ubuntu, sans-serif",
            fontWeight:'bold'
        },
        h2: {
            fontFamily: "Ubuntu, sans-serif",
            fontWeight:'bold'
        },
        h3: {
            fontFamily: "Ubuntu, sans-serif",
            fontWeight:'bold'
        },
        h4: {
            fontFamily: "Ubuntu, sans-serif",
            fontWeight:'bold'
        },
        h5: {
            fontFamily: "Ubuntu, sans-serif",
            fontWeight:'bold'
        },
        h6: {
            fontFamily: "Ubuntu, sans-serif",
            fontWeight:'bold'
        },
        fontFamily: "Lato, sans-serif",
        fontWeight:'600'
    },
});

export default theme;
